import { Empty } from "antd";
import React from "react";
const defaultImageUrl = `${process.env.REACT_APP_BASE_URL}/images/inventory-default.png`;

export const RootedEmpty = (x: string | undefined) => {
  return <Empty image={defaultImageUrl} description="There's no data to show yet."></Empty>;
};
